export default "__VITE_PUBLIC_ASSET__c40de128__"